import { useState } from "react";
import styles from "./Bubbles.module.scss";
import ApeSVG from "../assets/bubbles/ape.svg";
import ArbSVG from "../assets/bubbles/arb.svg";
import BomeSVG from "../assets/bubbles/bome.svg";
import CompSVG from "../assets/bubbles/comp.svg";
import DaiSVG from "../assets/bubbles/dai.svg";
import DriftSVG from "../assets/bubbles/drift.svg";
import EthSVG from "../assets/bubbles/eth.svg";
import HeliumSVG from "../assets/bubbles/helium.svg";
import JtoSVG from "../assets/bubbles/jto.svg";
import JupSVG from "../assets/bubbles/jup.svg";
import MetaplexSVG from "../assets/bubbles/metaplex.svg";
import MyroSVG from "../assets/bubbles/myro.svg";
import OpSVG from "../assets/bubbles/op.svg";
import OrcaSVG from "../assets/bubbles/orca.svg";
import PolygonSVG from "../assets/bubbles/polygon.svg";
import PythSVG from "../assets/bubbles/pyth.svg";
import RenderSVG from "../assets/bubbles/render.svg";
import ShibSVG from "../assets/bubbles/shib.svg";
import SnxSVG from "../assets/bubbles/snx.svg";
import SolSVG from "../assets/bubbles/sol.svg";
import UniSVG from "../assets/bubbles/uni.svg";
import UsdcSVG from "../assets/bubbles/usdc.svg";
import WifSVG from "../assets/bubbles/wif.svg";
import WormholeSVG from "../assets/bubbles/wormhole.svg";

type BubbleType = {
  id: number;
  left: string;
  top: string;
  size: string;
  animation: string;
  isVisible: boolean;
  img: string;
  alt: string;
};

const LOGOS: Pick<BubbleType, "img" | "alt">[] = [
  {
    img: ApeSVG,
    alt: "Ape",
  },
  {
    img: ArbSVG,
    alt: "Arbitrum",
  },
  {
    img: BomeSVG,
    alt: "Bome",
  },
  {
    img: CompSVG,
    alt: "Comp",
  },
  {
    img: DaiSVG,
    alt: "Dai",
  },
  {
    img: DriftSVG,
    alt: "Drift",
  },
  {
    img: EthSVG,
    alt: "Eth",
  },
  {
    img: HeliumSVG,
    alt: "Helium",
  },
  {
    img: JtoSVG,
    alt: "Jto",
  },
  {
    img: JupSVG,
    alt: "Jup",
  },
  {
    img: MetaplexSVG,
    alt: "Metaplex",
  },
  {
    img: MyroSVG,
    alt: "Myro",
  },
  {
    img: OpSVG,
    alt: "Op",
  },
  {
    img: OrcaSVG,
    alt: "Orca",
  },
  {
    img: PolygonSVG,
    alt: "Polygon",
  },
  {
    img: PythSVG,
    alt: "Pyth",
  },
  {
    img: RenderSVG,
    alt: "Render",
  },
  {
    img: ShibSVG,
    alt: "Shib",
  },
  {
    img: SnxSVG,
    alt: "Snx",
  },
  {
    img: SolSVG,
    alt: "Sol",
  },
  {
    img: UniSVG,
    alt: "Uni",
  },
  {
    img: UsdcSVG,
    alt: "Usdc",
  },
  {
    img: WifSVG,
    alt: "Wif",
  },
  {
    img: WormholeSVG,
    alt: "Wormhole",
  },
];

export const Bubbles = () => {
  const [bubbles, setBubbles] = useState<BubbleType[]>(
    LOGOS.map((logos, index) => ({
      ...logos,
      id: index,
      left: `${Math.random() * 70}%`,
      top: `${Math.random() * 80}%`,
      size: `${Math.random() * (100 - 50) + 50}px`,
      animation: `${styles.animateBubble} ${Math.random() * (60 - 20) + 20}s linear infinite, ${styles.sideways} ${Math.random() * (10 - 4) + 4}s ease-in-out infinite alternate`,
      isVisible: true,
    })),
  );

  const handleBubbleClick = (id: number) => {
    setBubbles((currentBubbles) =>
      currentBubbles.map((bubble) => {
        if (bubble.id === id) {
          setTimeout(() => {
            setBubbles((current) =>
              current.map((b) => {
                if (b.id === id) {
                  return { ...b, top: "100%", isVisible: true };
                }
                return b;
              }),
            );
          }, 5000);
          return { ...bubble, isVisible: false };
        }
        return bubble;
      }),
    );
  };

  return (
    <div className={styles.bubbles}>
      {bubbles.map(
        (bubble) =>
          bubble.isVisible && (
            <Bubble
              key={bubble.id}
              bubble={bubble}
              onClick={() => handleBubbleClick(bubble.id)}
            />
          ),
      )}
    </div>
  );
};

const Bubble = ({
  bubble,
  onClick,
}: {
  bubble: BubbleType;
  onClick: () => void;
}) => (
  <div
    className={styles.bubble}
    style={{
      left: bubble.left,
      top: bubble.top,
      width: bubble.size,
      height: bubble.size,
      animation: bubble.animation,
      WebkitAnimation: bubble.animation,
    }}
    onClick={onClick}
  >
    <img src={bubble.img} alt={bubble.alt} />
  </div>
);
